//clinic list types
export const CLINIC_LIST = 'CLINIC_LIST'
export const CLINIC_LIST_RES = 'CLINIC_LIST_RES'

//switch clinic types
export const SWITCH_CLINIC = 'SWITCH_CLINIC'
export const SWITCH_CLINIC_RES = 'SWITCH_CLINIC_RES'
export const CLEAR_SWITCH_RES = 'CLEAR_SWITCH_RES'
